export { default as VictoryErrorBar } from "./victory-errorbar";
export { default as ErrorBar } from "./error-bar";


//////////////////
// WEBPACK FOOTER
// ./~/victory-errorbar/es/index.js
// module id = 2477
// module chunks = 0